/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An enumeration.
 * @export
 */
export const ContainerRegistryTypeEnum = {
    Ecr: 'ecr',
    Gar: 'gar',
    DockerHub: 'docker_hub'
} as const;
export type ContainerRegistryTypeEnum = typeof ContainerRegistryTypeEnum[keyof typeof ContainerRegistryTypeEnum];


export function ContainerRegistryTypeEnumFromJSON(json: any): ContainerRegistryTypeEnum {
    return ContainerRegistryTypeEnumFromJSONTyped(json, false);
}

export function ContainerRegistryTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContainerRegistryTypeEnum {
    return json as ContainerRegistryTypeEnum;
}

export function ContainerRegistryTypeEnumToJSON(value?: ContainerRegistryTypeEnum | null): any {
    return value as any;
}

